type CreateDeeplinkUrlParams = {
  baseUrl: string;
  params: Record<string, string | undefined>;
};

const createDeeplinkUrl = ({ baseUrl, params }: CreateDeeplinkUrlParams) => {
  const queryParams = Object.entries(params)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
};

export { createDeeplinkUrl };
